import React, { type FC } from 'react';

export const SignalDiscountRebrandSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.33073 13.3359L2.66406 8.66927L7.9974 3.33594H11.9974C12.3656 3.33594 12.6641 3.63441 12.6641 4.0026V8.0026L7.33073 13.3359ZM10.6639 6.16927C11.1241 6.16927 11.4972 5.79618 11.4972 5.33594C11.4972 4.8757 11.1241 4.5026 10.6639 4.5026C10.2037 4.5026 9.83057 4.8757 9.83057 5.33594C9.83057 5.79618 10.2037 6.16927 10.6639 6.16927Z"
                fill="#324EFC"
            />
        </svg>
    );
};
